import { Injectable } from '@angular/core';
import { EMPTY, map, Observable, of, switchMap, take } from 'rxjs';
import { GET_FPCS_QUERY } from 'src/app/graphQL/queries/fpc-queries';
import { FpcFamily } from 'src/app/models/dto/fpc-family';
import { ApolloClientService } from './apollo-client.service';
import { convertGraphQLPresignedUrlToString } from 'src/app/graphQL/mappers/fpc.mappers';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { GraphQLPresignedUrlOutput } from 'src/app/graphQL/models/output/graphql-presignedUrl-output';


@Injectable({
  providedIn: 'root'
})
export class FpcsApiService {

  constructor(private apolloClientService: ApolloClientService,
    private http: HttpClient) {}

  get(): Observable<FpcFamily[]> {
    return this.apolloClientService.apolloClient$.pipe(
      take(1),
      switchMap(client =>
        client.query<{configuratorFpcs: GraphQLPresignedUrlOutput}>({
          query: GET_FPCS_QUERY,
        })
      ),
      map(results => {
        const url = results?.data?.configuratorFpcs;
        return convertGraphQLPresignedUrlToString(url) ?? '';
      }),
      switchMap(url => this.http.get<any[]>(url, { withCredentials: false })),
      map(rawFamilies => (rawFamilies ?? []).map(fam => ({
        fpcCode: fam.fpcCode,
        name: fam.name,
        notCondition: false,
        variants: (fam.variants ?? [])
          .map((v: any) => ({
            fpcCode: v.fpcCode,
            name: v.name,
            notCondition: false
          }))
      } as FpcFamily)))
    );
  }
}
